export default "__VITE_ASSET__BDdGeiRW__"